export default __webpack_public_path__ + "static/media/nagrody.80a42d33.jpg";